import { emptySettings } from "../landingEditor/config";
import { defaultLandingLayout, getLandingSegments } from "../landingEditor/landingLayout";

function clone(value) {
  if (typeof structuredClone === "function") return structuredClone(value);
  return JSON.parse(JSON.stringify(value));
}

function isDefaultLayout(form) {
  const current = getLandingSegments(form);
  const defaults = defaultLandingLayout().segments;
  if (JSON.stringify(form?.sections || {}) !== JSON.stringify(emptySettings.sections || {})) return false;
  if (current.length !== defaults.length) return false;
  return current.every((segment, index) => {
    const expected = defaults[index];
    return segment.id === expected.id
      && segment.type === expected.type
      && segment.visible !== false
      && !segment.anchor
      && !segment.data
      && (!segment.visualStyle || Object.keys(segment.visualStyle).length === 0);
  });
}

function isDefaultHighlights(form) {
  return JSON.stringify(form?.highlightsIntro || {}) === JSON.stringify(emptySettings.highlightsIntro)
    && JSON.stringify(form?.highlights || []) === JSON.stringify(emptySettings.highlights);
}

function isDefaultBrands(form) {
  return JSON.stringify(form?.catalog?.brands || {}) === JSON.stringify(emptySettings.catalog.brands);
}

function isDefaultSpotlight(form) {
  return JSON.stringify(form?.catalog?.spotlight || {}) === JSON.stringify(emptySettings.catalog.spotlight);
}

export function inspectGastronomicLandingPreset(form = {}) {
  const next = clone(form);
  const changes = [];
  const groups = new Set();
  const structureDefault = isDefaultLayout(form);

  if ((next.catalog?.homeSource || "catalog") !== "gastronomicMenu") {
    next.catalog = { ...(next.catalog || {}), homeSource: "gastronomicMenu" };
    changes.push("catalog.homeSource");
    groups.add("content");
  }

  if (structureDefault) {
    const layout = getLandingSegments(next);
    const byType = Object.fromEntries(layout.map((segment) => [segment.type, segment]));
    const order = ["navbar", "hero", "featured", "categories", "about", "highlights", "contact", "spotlight", "brands", "footer"];
    next.layout = { segments: order.map((type) => clone(byType[type])).filter(Boolean) };
    changes.push("layout.segments");
    groups.add("structure");

    next.sections = { ...(next.sections || {}) };
    if (isDefaultSpotlight(form) && next.sections.showSpotlight !== false) {
      next.sections.showSpotlight = false;
      changes.push("sections.showSpotlight");
    }
    if (isDefaultBrands(form) && next.sections.showBrands !== false) {
      next.sections.showBrands = false;
      changes.push("sections.showBrands");
    }
    if (isDefaultHighlights(form) && next.sections.showHighlights !== false) {
      next.sections.showHighlights = false;
      changes.push("sections.showHighlights");
    }
  }

  return {
    nextForm: next,
    changed: changes.length > 0,
    changes,
    groups: [...groups],
    structureDefault,
  };
}
